import React from 'react';

import type { ConnectionState, DevContextProps } from './../../ricos-context';
import { DevContext } from './../../ricos-context';

export const DevContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const existingValue = React.useContext(DevContext);
  const [connectionState, setConnectionState] = React.useState<ConnectionState>({
    type: 'NO_MODIFICATION',
  });

  const currentValue = React.useMemo(() => {
    const renderCountChangeListeners = new Set<(renderCounts: Map<string, number>) => void>();

    const testingProviderValue: DevContextProps = {
      renderCounts: new Map<string, number>(),
      trackRender: (componentName: string) => {
        testingProviderValue.renderCounts?.set(
          componentName,
          (testingProviderValue.renderCounts?.get(componentName) || 0) + 1
        );

        renderCountChangeListeners.forEach(listener => {
          if (testingProviderValue.renderCounts) {
            listener(testingProviderValue.renderCounts);
          }
        });
      },
      onRenderCountChange: listener => {
        renderCountChangeListeners.add(listener);

        return () => {
          renderCountChangeListeners.delete(listener);
        };
      },
      resetRenderCounts: () => {
        testingProviderValue.renderCounts?.forEach((_, key) => {
          testingProviderValue.renderCounts?.set(key, 0);
        });

        renderCountChangeListeners.forEach(listener => {
          if (testingProviderValue.renderCounts) {
            listener(testingProviderValue.renderCounts);
          }
        });
      },
      connectionState,
      setConnectionState,
    };

    return { ...testingProviderValue, ...existingValue };
  }, [existingValue, connectionState]);

  return <DevContext.Provider value={currentValue}>{children}</DevContext.Provider>;
};
